export const QA_NAME_APPLICANT_PROFILE_WIDGET_STAGE_SCREENING =
  'applicantProfileWidgetStageScreening'

export const QA_NAME_APPLICANT_PROFILE_STAGE_MIRROR =
  'applicantProfileStageMirror'

export const APPLICANT_STAGE_SCREENING_SKELETON_GROUP_ROW_COUNT = [4, 3]
